import {ACCESS_TOKEN} from "../constants/auth";
import {API_BASE_URL} from "../constants/api";
import axios from "axios";

const FormService = {};
FormService.saveForm = async function (applicationId) {
    let data = new FormData();
    data.append("applicationId", applicationId);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/form/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.saveFormMultiple = async function (applicationIds) {
    let data = new FormData();
    data.append("applicationIds", applicationIds);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/form/save/multiple",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.addIdCardFileToForm = async function (formId, fileId) {
    let data = new FormData();
    data.append("fileId", fileId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/${formId}/add/file/idCard`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            // 'Authorization': `${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}
FormService.addPreferentialFileToForm = async function (formId, fileId) {
    let data = new FormData();
    data.append("fileId", fileId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/${formId}/add/file/preferential`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            // 'Authorization': `${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}
FormService.addOtherFileToForm = async function (formId, fileId) {
    let data = new FormData();
    data.append("fileId", fileId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/${formId}/add/file/other`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            // 'Authorization': `${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}
FormService.deleteFileFromForm = async function (formId, fileId) {
    let data = new FormData();
    data.append("fileId", fileId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/${formId}/delete/file`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            // 'Authorization': `${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.completeFormById = async function (formId) {

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/${formId}/complete`,
        // headers: {
        //     'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        // }
    });
}

FormService.adminApprove = async function (formId, userId) {
    let data = new FormData();
    data.append("formId", formId);
    data.append("userId", userId);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/form/approve",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.reopenFormById = async function (formId, userId) {
    let data = new FormData();
    data.append("userId", userId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/form/${formId}/reopen`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// Пересобрать договор по актуальному шаблону и текущему подписанту из «Глобальных данных».
// Нужно для договоров, сформированных до того, как подписант стал редактируемым:
// у них снимок шаблона хранит прежнюю должность и ФИО текстом. Доступно только без подписей.
FormService.regenerateFormById = async function (formId, userId) {
    let data = new FormData();
    data.append("userId", userId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/form/${formId}/regenerate`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// То же самое по сформированным, но никем не подписанным договорам — пачкой по limit штук,
// начиная со смещения offset. Ответ: {regenerated, failed, total, nextOffset}.
// Пересборка одного договора — это рендер PDF (~1,5 с), поэтому очередь проходится
// повторными вызовами: следующий вызов идёт с nextOffset, и так пока nextOffset < total.
FormService.regenerateUnsignedForms = async function (userId, offset = 0, limit = 15) {
    let data = new FormData();
    data.append("userId", userId);
    data.append("offset", offset);
    data.append("limit", limit);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/form/regenerate/unsigned",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.contractFormById = async function (formId) {

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/form/${formId}/contract`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.getFormById = async function (formId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/form/get/${formId}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
}

FormService.updateFormById = async function (formId, formSave) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/form/update/${formId}`,
        headers: {
            "Content-Type": "application/json"
        },
        data: formSave
    });
}

FormService.updateFormAdminById = async function (formId, formSave) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/form/update/${formId}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        },
        data: formSave
    });
}

FormService.updateDiscountOfFormById = async function (formId, discount, discountName) {
    let data = new FormData();
    data.append("discount", discount);
    data.append("discountName", discountName);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/form/update/${formId}/discount`,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        data: data
    });
}

FormService.saveSignatureInForm = async function (formId, iin, fullName, docTemplate, docDetails, signDate, signature) {
    let data = new FormData();
    data.append("formId", formId);
    data.append("iin", iin);
    data.append("fullName", fullName);
    data.append("docTemplate", docTemplate);
    data.append("docDetails", docDetails);
    data.append("signDate", signDate);
    data.append("signature", signature);
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/form/sign`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

FormService.saveAdminSignatureInForm = async function (signature) {
    let data = new FormData();
    data.append("signature", signature);
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/form/sign`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.getAllFormsPageableByType = async function (page, limit, type, categoryId, applicationStatus) {
    if (type === undefined) {
        type = null;
    }
    if (categoryId === undefined) {
        categoryId = null;
    }
    if (applicationStatus === undefined) {
        applicationStatus = null;
    }
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/form/get/${type}`,
        params: {
            page: page - 1,
            limit: limit,
            categoryId: categoryId,
            status: applicationStatus
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

FormService.countFormsByType = async function (type) {
    if (type === undefined) {
        type = null;
    }
    return await axios({
        method: "get",
        url: API_BASE_URL + `/api/form/get/${type}/count`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    })
}

FormService.directorApprove = async function (formId) {
    let data = new FormData();
    data.append("formId", formId);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/form/approveDirector",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

FormService.rejectFormsByIds = async function (ids, userId) {
    let data = new FormData();
    data.append("ids", ids);
    data.append("userId", userId);

    return axios({
        method: "post",
        url: API_BASE_URL + '/api/admin/form/reject',
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default FormService;